import { applyMiddleware, compose, createStore as createReduxStore } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducer";

let composeEnhancers = compose;
let store = null;

if (process.env.NODE_ENV === "development" && typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    console.log("included redux devtools");
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

const middlewareRootState = store => next => action => {
    next({ ...action, getState: store.getState });
};

const initialData = (typeof window !== "undefined" && window.MIBABY_INITIAL_DATA) || {};

const getNewStore = (data = initialData, reducer = rootReducer, mergeInitialData = true) =>
    createReduxStore(
        reducer,
        mergeInitialData ? { ...initialData, ...data } : data,
        composeEnhancers(applyMiddleware(thunk), applyMiddleware(middlewareRootState))
    );

function createStore(data, reducer, mergeInitialData) {
    store = getNewStore(data, reducer, mergeInitialData);
}

if (process.env.NODE_ENV !== "development" && typeof window !== "undefined") {
    delete window.MIBABY_INITIAL_DATA;
}

export { createStore, getNewStore, store };
